import { render } from "./sceneEditBox.vue?vue&type=template&id=7796e966&scoped=true&ts=true&lang=pug"
import script from "./sceneEditBox.vue?vue&type=script&lang=ts"
export * from "./sceneEditBox.vue?vue&type=script&lang=ts"

import "./sceneEditBox.vue?vue&type=style&index=0&id=7796e966&lang=stylus&scoped=true"

import exportComponent from "/builds/findsoft/hero/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7796e966"]])

export default __exports__